<div class="full-page">
  <img class="shared-login-banner" draggable="false" [src]="'logo/logo.png' | contentAssetImage" />
  <div class="content">
    <img class="logo mb-3" draggable="false" [src]="'placeholders/engineering.svg' | contentAssetImage" />

    <div class="text-center title">
      {{ 'maintenancepage.currentlyunavailable.title' | translate }}
    </div>
    <div class="maintenance-text" [innerHTML]="'maintenancepage.currentlyunavailable.text' | translate | markdownTranslate"></div>
  </div>
</div>
